import { Logo } from '@vst/beam';
import { ViasatLogoDefault } from '@vst/beam-icons/logos/viasat';

import styles from './styles.module.scss';

const ViasatLogo = ({
  logoUrl,
  onClick,
  showLanguageToggle,
}: {
  logoUrl: string;
  onClick: React.MouseEventHandler<HTMLAnchorElement>;
  showLanguageToggle?: boolean;
}) => {
  const className = showLanguageToggle
    ? styles.logo
    : `${styles.logo} ${styles.noLanguageToggle}`;

  return (
    <a href={logoUrl} className={className} onClick={onClick}>
      <Logo logo={ViasatLogoDefault} alt="Viasat" size="112px" />
    </a>
  );
};
export default ViasatLogo;
